import React from "react";

import { useDispatch, useSelector } from "react-redux";
import { closeSnackbar } from "../../store/actions/snackbarSlice";

// MATERIAL UI
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
// ICONS

const SnackbarManager = () => {
  const dispatch = useDispatch();

  const messages = useSelector((state) => state.snackbar.messages);

  const handleClose = (key) => () => {
    dispatch(closeSnackbar({ key }));
  };

  return (
    <>
      {messages.map((message) => (
        <Snackbar
          key={`snackbar${message.key}`}
          open={true} // Assuming all messages are open until closed
          autoHideDuration={message.autoHideDuration || 4000} // Default auto hide duration
          onClose={handleClose(message.key)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          sx={{ zIndex: 99999999 }}
        >
          <Alert
            variant="filled"
            onClose={handleClose(message.key)}
            severity={message.severity || "info"} // Default severity
          >
            {message.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

export default SnackbarManager;
